(function () {
  /* ---------- Privat- / Geschäftskunden ---------- */
  var VAT = (window.GW && window.GW.vat) || 19;
  var CUR = (window.GW && window.GW.currency) || 'EUR';
  function fmt(cents) { return (cents / 100).toLocaleString('de-DE', { style: 'currency', currency: CUR }); }
  function isB2B() { return document.documentElement.getAttribute('data-audience') === 'b2b'; }
  function net(cents) { return Math.round(cents / (1 + VAT / 100)); }
  function applyAudience() {
    var b2b = isB2B();
    document.querySelectorAll('[data-money][data-cents]').forEach(function (el) {
      var c = parseInt(el.getAttribute('data-cents'), 10);
      if (isNaN(c)) return;
      el.textContent = fmt(b2b ? net(c) : c);
    });
    document.querySelectorAll('[data-vat-of]').forEach(function (el) {
      var c = parseInt(el.getAttribute('data-vat-of'), 10);
      if (!isNaN(c)) el.textContent = fmt(c - net(c));
    });
    document.querySelectorAll('[data-set-audience]').forEach(function (btn) {
      if (btn.tagName === 'BUTTON') btn.setAttribute('aria-pressed', btn.getAttribute('data-set-audience') === (b2b ? 'b2b' : 'b2c') ? 'true' : 'false');
    });
  }
  function setAudience(a) {
    document.documentElement.setAttribute('data-audience', a);
    try { localStorage.setItem('gw_audience', a); } catch (e) {}
    applyAudience();
    document.dispatchEvent(new CustomEvent('gw:audience', { detail: { audience: a } }));
  }
  window.GW = window.GW || {};
  window.GW.fmt = fmt; window.GW.net = net; window.GW.isB2B = isB2B;
  window.GW.applyAudience = applyAudience; window.GW.setAudience = setAudience;
  /* Geschäftskunden-Ansicht erst nach Bestätigung der Unternehmereigenschaft (§ 14 BGB) */
  var dlg = document.querySelector('[data-b2b-dialog]');
  function b2bConfirmed() { try { return localStorage.getItem('gw_b2b_ok') === '1'; } catch (e) { return false; } }
  function askB2B() {
    if (!dlg || typeof dlg.showModal !== 'function') {
      if (window.confirm('Die Geschäftskunden-Ansicht ist nur für Unternehmer (§ 14 BGB). Für Bestellungen als Unternehmer besteht kein Widerrufsrecht. Bestätigst du, dass du als Unternehmer bestellst?')) {
        try { localStorage.setItem('gw_b2b_ok', '1'); } catch (e) {}
        setAudience('b2b');
      }
      return;
    }
    var chk = dlg.querySelector('[data-b2b-check]'), ok = dlg.querySelector('[data-b2b-confirm]');
    chk.checked = false; ok.disabled = true;
    dlg.showModal();
  }
  if (dlg) {
    var chk0 = dlg.querySelector('[data-b2b-check]'), ok0 = dlg.querySelector('[data-b2b-confirm]');
    chk0.addEventListener('change', function () { ok0.disabled = !chk0.checked; });
    ok0.addEventListener('click', function () {
      if (!chk0.checked) return;
      try { localStorage.setItem('gw_b2b_ok', '1'); } catch (e) {}
      dlg.close(); setAudience('b2b');
    });
    dlg.querySelector('[data-b2b-cancel]').addEventListener('click', function () { dlg.close(); setAudience('b2c'); });
  }
  // Ohne Bestätigung keine Geschäftskunden-Ansicht (z. B. alte Einstellung im Browser)
  if (dlg && isB2B() && !b2bConfirmed()) {
    document.documentElement.setAttribute('data-audience', 'b2c');
    try { localStorage.setItem('gw_audience', 'b2c'); } catch (e) {}
  }
  document.addEventListener('click', function (e) {
    var el = e.target.closest('[data-set-audience]');
    if (!el) return;
    var a = el.getAttribute('data-set-audience');
    if (a === 'b2b' && !isB2B() && !b2bConfirmed()) { e.preventDefault(); askB2B(); return; }
    setAudience(a);
  });
  applyAudience();

  /* ---------- Navigation ---------- */
  var hdr = document.querySelector('[data-header]');
  var burger = document.querySelector('[data-nav-toggle]');
  if (hdr && burger) {
    burger.addEventListener('click', function () {
      var open = hdr.classList.toggle('open');
      burger.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }
  document.querySelectorAll('[data-sub-toggle]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var li = btn.parentElement;
      var open = li.classList.toggle('sub-open');
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  });

  /* ---------- Produktseite ---------- */
  document.querySelectorAll('[data-product]').forEach(function (root) {
    var main = root.querySelector('[data-main-image]');
    var thumbs = root.querySelectorAll('[data-thumb]');
    thumbs.forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (main) {
          main.src = btn.getAttribute('data-src');
          main.srcset = btn.getAttribute('data-srcset') || '';
          main.alt = btn.getAttribute('data-alt') || '';
        }
        thumbs.forEach(function (b) { b.setAttribute('aria-current', 'false'); });
        btn.setAttribute('aria-current', 'true');
      });
    });
    var data = root.querySelector('[data-variants]');
    if (!data || !root.querySelector('[data-option]')) return;
    var variants = JSON.parse(data.textContent);
    var total = parseInt(root.getAttribute('data-total') || '0', 10);
    var idInput = root.querySelector('[data-variant-id]');
    var priceEl = root.querySelector('[data-price]');
    var addBtn = root.querySelector('[data-add]');
    var seq = 0;

    function apply(v) {
      if (!v) {
        if (addBtn) { addBtn.disabled = true; addBtn.textContent = 'Nicht verfügbar'; }
        return;
      }
      if (idInput) idInput.value = v.id;
      if (priceEl) { priceEl.setAttribute('data-cents', v.price); applyAudience(); }
      if (addBtn) {
        addBtn.disabled = !v.available;
        addBtn.textContent = v.available ? 'In den Warenkorb' : 'Ausverkauft';
      }
      var img = v.image || (v.featured_image && v.featured_image.src);
      if (img && main) {
        main.src = img + (img.indexOf('width=') > -1 ? '' : (img.indexOf('?') > -1 ? '&' : '?') + 'width=900');
        main.removeAttribute('srcset');
      }
      try {
        var u = new URL(window.location.href);
        u.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', u);
      } catch (e) {}
    }
    function update() {
      var selected = [], ids = [];
      root.querySelectorAll('[data-option]').forEach(function (set) {
        var c = set.querySelector('input:checked');
        selected.push(c ? c.value : null);
        ids.push(c ? c.getAttribute('data-ov-id') : '');
      });
      var v = variants.filter(function (x) {
        return x.options.every(function (o, i) { return o === selected[i]; });
      })[0];
      if (v || variants.length >= total || !window.fetch) { apply(v); return; }
      // Mehr als 250 Varianten: Variante beim Server abfragen
      var my = ++seq;
      if (addBtn) addBtn.disabled = true;
      fetch(root.getAttribute('data-url') + '?view=gw-varmap&option_values=' + ids.join(','))
        .then(function (r) { return r.json(); })
        .then(function (j) {
          if (my !== seq) return;
          var cur = j.current;
          if (cur && cur.id) {
            cur.options = selected.slice();
            variants.push(cur);
          }
          apply(cur && cur.id ? cur : null);
        })
        .catch(function () { apply(null); });
    }
    root.querySelectorAll('[data-option] input').forEach(function (input) {
      input.addEventListener('change', update);
    });
  });

  /* ---------- Warenkorb: ganze Konfiguration entfernen ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-cfg-remove]');
    if (!btn) return;
    var cfg = btn.getAttribute('data-cfg-remove');
    var updates = {};
    document.querySelectorAll('[data-cfg="' + cfg + '"]').forEach(function (line) { updates[line.getAttribute('data-key')] = 0; });
    btn.disabled = true;
    fetch((window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart/update.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ updates: updates })
    }).then(function () { window.location.reload(); }).catch(function () { window.location.reload(); });
  });
})();
